import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import UserLink from '../../../User/Link/UserLink';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import DeviationFlags from '../../buttons/DeviationFlags';
import ExpandButton from '../../buttons/ExpandButton';
import { getDeviationTitle } from '../../../DeviationViews/_helpers';
import s from './ExpandActionBar.scss';
const ExpandActionBar = ({ deviation , deviation: { author  } , isOwner  })=>{
    const { hasFlag , isPrintPurchasable  } = useDeviationAttributes(deviation, isOwner);
    const deviationTitle = getDeviationTitle(deviation);
    const showTitle = !!deviationTitle;
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], hasFlag && s['with-badge'], isPrintPurchasable && s['with-print']),
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['badge']
    }, hasFlag && /*#__PURE__*/ React.createElement(DeviationFlags, {
        deviation: deviation,
        alwaysExpanded: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, showTitle && /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, deviationTitle), author && /*#__PURE__*/ React.createElement("div", {
        className: s['author']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "common.created.byLink"
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['by']
    }, "By"), " ", /*#__PURE__*/ React.createElement(UserLink, {
        user: author
    })))), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: s['right-block']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['view-switcher']
    }, /*#__PURE__*/ React.createElement(ExpandButton, {
        deviation: deviation
    }))));
};
ExpandActionBar.displayName = 'ExpandActionBar';
export default ExpandActionBar;
